import { DotChartOutlined } from "@ant-design/icons";
import { Flex, Skeleton } from "antd";

import { ComponentContainer, LayoutGrid } from "../../LayoutContainers";
import { colors } from "../../../utils/variables";

export const SkeletonProductDetail = () => {
    return (
        <>
            <ComponentContainer bgColor={colors.blackish} classNames="skeleton-product-detail">
                <LayoutGrid spacingTop="8" spacingBottom="4" cols={1}>
                    <Skeleton active={true} />

                    <Flex className="mb-2 mt-2" gap="1.5rem" justify="flex-end">
                        <Skeleton.Input active={true} />
                        <Skeleton.Input active={true} />
                    </Flex>

                    <Flex className="mb-2 mt-2" gap="1.5rem">
                        <Skeleton.Input className="home__price-ticker --desktop-only" active={true} />
                        <Skeleton.Input className="home__price-ticker" active={true} />
                    </Flex>

                    <Flex>
                        <Skeleton.Input className="home__price-ticker" active={true} />
                    </Flex>

                    <Flex className="--mobile-only mb-2 mt-2">
                        <Skeleton.Input className="home__price-ticker" active={true} />
                    </Flex>
                </LayoutGrid>
            </ComponentContainer>

            <ComponentContainer bgColor={colors.blackish_20}>
                <LayoutGrid spacingTop="2" spacingBottom="4" cols={1}>
                    <Flex className="mb-8 mt-2" gap="1.5rem">
                        <Skeleton.Input active={true} />
                        <Skeleton.Input active={true} />
                        <Skeleton.Input active={true} />
                        <Skeleton.Input active={true} />
                        <Skeleton.Input active={true} />
                    </Flex>

                    <Skeleton active={true} />
                </LayoutGrid>
            </ComponentContainer>
        </>
    );
};

// export const SkeletonChart = () => {
//     return <Skeleton active={true} />;
// };

export const SkeletonChart = () => {
    return (
        <div className="skeleton-line-chart">
            <Skeleton.Node active={true}>
                <DotChartOutlined
                    style={{
                        fontSize: 80,
                        color: "#bfbfbf",
                    }}
                />
            </Skeleton.Node>
        </div>
    );
};
